import React, { useId } from "react";
import PropTypes from "prop-types";

const Toggle = ({ className = "", description, id, label, ...props }) => {
  const generatedId = useId();
  const controlId = id || generatedId;
  return (
    <label className={["wsm-toggle", className].filter(Boolean).join(" ")} htmlFor={controlId}>
      <span className="wsm-toggle__content">
        <span className="wsm-toggle__label">{label}</span>
        {description && <span className="wsm-toggle__description">{description}</span>}
      </span>
      <span className="wsm-toggle__control">
        <input {...props} id={controlId} role="switch" type="checkbox" />
        <span className="wsm-toggle__track"><span className="wsm-toggle__thumb" /></span>
      </span>
    </label>
  );
};

Toggle.propTypes = { className: PropTypes.string, description: PropTypes.string, id: PropTypes.string, label: PropTypes.node.isRequired };
export default Toggle;
